import { useState, useContext } from "react";
import {
  TbDashboard, TbBuilding, TbBuildingStore,
  TbCalendarCheck, TbUsers, TbCash,
  TbLogout, TbLayoutSidebarLeftCollapse, TbLayoutSidebarLeftExpand
} from "react-icons/tb";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import AgencyDashboard from "./components/AgencyDashboard";
import AgencyHotels from "./components/AgencyHotels";
import AgencyCreateHotel from "./components/AgencyCreateHotel";
import AgencyReservations from "./components/AgencyReservations";
import AgencyOwners from "./components/AgencyOwners";
import AgencyPayouts from "./components/AgencyPayouts";

const NAV = [
  { section: "Principal" },
  { key: "dashboard",     label: "Dashboard",        icon: TbDashboard },
  { divider: true },
  { section: "Biens" },
  { key: "hotels",        label: "Mes biens",        icon: TbBuildingStore },
  { key: "create-hotel",  label: "Ajouter un bien",  icon: TbBuilding },
  { divider: true },
  { section: "Activité" },
  { key: "reservations",  label: "Réservations",     icon: TbCalendarCheck },
  { divider: true },
  { section: "Financier" },
  { key: "owners",        label: "Propriétaires",    icon: TbUsers },
  { key: "payouts",       label: "Reversements",     icon: TbCash },
];

export default function Agency() {
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState("dashboard");
  const [collapsed, setCollapsed]   = useState(false);

  const renderPage = () => {
    switch (activePage) {
      case "hotels":       return <AgencyHotels setActivePage={setActivePage} />;
      case "create-hotel": return <AgencyCreateHotel setActivePage={setActivePage} />;
      case "reservations": return <AgencyReservations />;
      case "owners":       return <AgencyOwners />;
      case "payouts":      return <AgencyPayouts />;
      default:             return <AgencyDashboard setActivePage={setActivePage} />;
    }
  };

  const handleLogout = async () => {
    try {
      await fetch("https://api.komorotel.com/api/agency/logout", {
        method: "POST",
        credentials: "include",
      });
    } catch (_) {}
    Cookies.remove("agency_token", { path: "/", domain: ".komorotel.com" });
    navigate("/agency/login");
  };

  return (
    <div className="flex h-screen overflow-hidden bg-[#F8FAFC]">

      {/* ── SIDEBAR ─────────────────────────────────────────── */}
      <div className={`flex flex-col bg-white border-r border-gray-100 transition-all duration-200 shrink-0 ${collapsed ? "w-16" : "w-60"}`}>

        {/* Logo */}
        <div className="flex items-center justify-between px-4 py-4 border-b border-gray-100">
          {!collapsed && (
            <div>
              <p className="text-sm font-medium text-gray-900 leading-tight">Komorotel</p>
              <p className="text-[10px] text-gray-400">Espace agence</p>
            </div>
          )}
          <button
            onClick={() => setCollapsed(c => !c)}
            className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 text-gray-400 hover:bg-gray-50 transition shrink-0"
          >
            {collapsed
              ? <TbLayoutSidebarLeftExpand size={15} />
              : <TbLayoutSidebarLeftCollapse size={15} />}
          </button>
        </div>

        {/* Nav */}
        <nav className="flex-1 flex flex-col gap-0.5 px-2 py-2 overflow-y-auto">
          {NAV.map((item, i) => {
            if (item.divider) {
              return <div key={i} className="h-px bg-gray-100 my-1 mx-1" />;
            }
            if (item.section) {
              return !collapsed
                ? <p key={i} className="text-[10px] font-medium text-gray-400 uppercase tracking-widest px-2 pt-2 pb-1">{item.section}</p>
                : null;
            }
            const Icon = item.icon;
            const active = activePage === item.key;
            return (
              <button
                key={item.key}
                onClick={() => setActivePage(item.key)}
                title={collapsed ? item.label : undefined}
                className={`flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm transition-all text-left w-full
                  ${active
                    ? "bg-[var(--k-green-soft)] text-[var(--k-green-text)] font-medium"
                    : "text-gray-500 hover:bg-gray-50 hover:text-gray-900"
                  }`}
              >
                <Icon size={18} className="shrink-0" />
                {!collapsed && <span className="truncate">{item.label}</span>}
              </button>
            );
          })}
        </nav>

        {/* Bottom */}
        <div className="border-t border-gray-100 px-2 py-2">
          {!collapsed && (
            <div className="flex items-center gap-2.5 px-2.5 py-2 mb-1">
              <div className="w-7 h-7 rounded-full bg-[var(--k-green-soft)] text-[var(--k-green-text)] flex items-center justify-center text-xs font-medium shrink-0">
                AG
              </div>
              <div className="overflow-hidden">
                <p className="text-xs font-medium text-gray-900 truncate">Mon agence</p>
                <p className="text-xs text-gray-400">Partenaire Komorotel</p>
              </div>
            </div>
          )}
          <button
            onClick={handleLogout}
            title={collapsed ? "Déconnexion" : undefined}
            className="flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm text-red-400 hover:bg-red-50 hover:text-red-600 transition w-full"
          >
            <TbLogout size={18} className="shrink-0" />
            {!collapsed && <span>Déconnexion</span>}
          </button>
        </div>
      </div>

      {/* ── MAIN ────────────────────────────────────────────── */}
      <div className="flex-1 overflow-y-auto">
        {renderPage()}
      </div>
    </div>
  );
}